import { MutationTree } from 'vuex'
import { PalettesState } from './palettes.types'

export enum MutationTypes {
  SET_ALL_PALETTES = 'SET_ALL_PALETTES',
  SET_PALETTES_LOADING_ERROR = 'SET_PALETTES_LOADING_ERROR'
}

export const mutations: MutationTree<PalettesState> = {
  [MutationTypes.SET_ALL_PALETTES](state, palettes) {
    state.palettes = palettes
  },
  [MutationTypes.SET_PALETTES_LOADING_ERROR](state, error) {
    state.palettesLoadingError = error
  }
}
